var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.93333,
    fill: "url(#paint0_linear_55960_471)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6762 7.51969C17.8461 7.05949 18.3079 6.77446 18.7954 6.82895L20.4805 7.0173C21.1427 7.09132 21.5757 7.7477 21.3831 8.38564L16.5499 24.3953C16.3836 24.9461 15.8627 25.3122 15.2881 25.2819L11.923 25.1048C11.5642 25.0859 11.3263 24.7247 11.4507 24.3876L17.6762 7.51969Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26672 25.1351C4.26672 24.5287 4.80892 24.0572 5.40788 24.1524L7.92191 24.5521C13.3996 25.4231 18.9805 25.4231 24.4582 24.5521L27.8137 24.0186C27.971 23.9936 28.1134 24.1151 28.1134 24.2744C28.1134 24.3891 28.0379 24.4901 27.928 24.5227L26.1898 25.0376C19.6113 26.9866 12.673 27.3978 5.91039 26.2397L5.07187 26.0961C4.60676 26.0164 4.26672 25.607 4.26672 25.1351Z",
    fill: "url(#paint1_linear_55960_471)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55960_471",
    x1: 2.4,
    y1: 1.86667,
    x2: 30.9333,
    y2: 30.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#577EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0022FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55960_471",
    x1: 4.26672,
    y1: 25.9856,
    x2: 28.8001,
    y2: 26.1335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.495034,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "white",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewlogo);
export default __webpack_public_path__ + "static/media/newlogo.9fac4dbda062ca8b37504d27a469c656.svg";
export { ForwardRef as ReactComponent };